export function pluralize(count: number | undefined | null, singular: string, plural: string) {
  return count === 1 ? singular : plural;
}
